// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import routerActions from '../../actions/router';
import './SearchFormContainer.less';
import {SearchFormWrapper} from '../SearchFormWrapper/SearchFormWrapper';

type DispatchProps = {
    search: typeof routerActions.search,
    locationSearch: typeof routerActions.locationSearch
};

type Props = DispatchProps;

export const SearchFormContainer = ({search, locationSearch}: Props) => (
    <SearchFormWrapper onChange={search} onLocationChange={locationSearch} />
);

const mapDispatchToProps = {
    search: routerActions.search,
    locationSearch: routerActions.locationSearch
};

export default compose(connect(null, mapDispatchToProps))(SearchFormContainer);
